import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">GetPovd · Your Perspective, Amplified</p>
        <h1>Discover a New Way to Experience Life.</h1>
        <p className="lede">
          At GetPovd, we empower you to see the world from fresh perspectives. Explore our innovative solutions designed to enhance your everyday experiences.
        </p>
        <div className="cta-row">
          <a href="/explore" target="_blank">
            Explore Now
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Transform Your Experience</h2>
          <p>
            Our unique offerings are crafted to elevate your daily life, providing you with tools and insights that inspire and engage.
          </p>
        </article>
        <article>
          <h2>Personalize Your Journey</h2>
          <p>
            Tailor our services to fit your individual needs, ensuring that every interaction is meaningful and impactful.
          </p>
        </article>
        <article>
          <h2>Stay Ahead with Innovation</h2>
          <p>
            Join us as we continuously evolve, bringing you the latest advancements that keep you connected and informed.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;